import React, { useState, useEffect } from 'react';

import FormAutocomplete from 'components/FormFields/FormAutocomplete';
import { convertTimeView } from 'utils/time';

const TimeSettingFormItem = (props) => {
  const {
    id,
    name,
    timeFormat,
    timeList = [],
    time,
    setTime,
  } = props;
  const [options, setOptions] = useState(timeList);
  const formattedTime = convertTimeView(time, timeFormat);
  const handleInputChange = (e) => {
    const q = e.target.value;
    if (q === '') {
      setOptions(timeList);
      return;
    }
    const newOptions = timeList.filter(({ _value, label }) => {
      if (label && label.toLowerCase().includes(q.toLowerCase())) return true;
      if (_value && _value.toLowerCase().includes(q.toLowerCase())) return true;
      return false;
    });

    setOptions(newOptions);
  };

  const handleOptionSelect = (_value) => {
    setTime(_value);
  };

  const renderOption = ({ label, value: _value }, i) => {
    return (
      <button
        key={`autocomplete-option-${i}`}
        className="button--unstyled autocomplete__option"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => handleOptionSelect(_value)}
      >
        {label}
      </button>
    );
  };

  useEffect(() => {
    const _options = timeList.map(item => {
      if (item.value === time) {
        return { ...item, selected: true };
      }

      return item;
    });

     setOptions(_options);
  }, [timeList, time]);

  return (
    <FormAutocomplete
      id={id}
      name={name}
      onSubmit={setTime}
      value={formattedTime}
      options={options}
      onInputChange={handleInputChange}
      renderOption={renderOption}
      submitOnBlur
    />
  );
};

export default TimeSettingFormItem;
